const currencyFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

export const formatCurrency = (value) => currencyFormatter.format(Number(value) || 0);

export const roundMoney = (value) => Math.round((Number(value) || 0) * 100) / 100;

/**
 * Lê um número digitado aceitando vírgula (padrão brasileiro) e valores
 * incompletos como "12," — devolve null quando ainda não há número válido,
 * para que o campo continue mostrando exatamente o que foi digitado.
 */
export const parseDecimal = (raw) => {
  if (typeof raw === 'number') {
    return Number.isFinite(raw) ? raw : null;
  }

  const normalized = String(raw ?? '')
    .trim()
    .replace(/\s/g, '')
    .replace(',', '.');

  if (normalized === '' || !/^\d*\.?\d*$/.test(normalized)) {
    return null;
  }

  const parsed = Number(normalized);

  return Number.isFinite(parsed) ? parsed : null;
};

/** Converte um número em texto para exibir dentro de um campo (pt-BR). */
export const toInputValue = (value, decimals) => {
  const number = Number(value) || 0;
  const text = typeof decimals === 'number' ? number.toFixed(decimals) : String(number);

  return text.replace('.', ',');
};
